<template>
  <div v-if="visible" class="sh-members-modal-overlay" @click.self="cancel">
    <div class="sh-members-modal sh-block-confirm" role="dialog" aria-modal="true" aria-labelledby="sh-block-confirm-title">
      <span class="sh-members-modal-close" @click="cancel">
        <i class="fal fa-times" aria-hidden="true"></i>
      </span>
      <h3 id="sh-block-confirm-title" class="sh-block-confirm-title">{{ copy.title }}</h3>
      <p class="sh-block-confirm-body">{{ copy.body }}</p>
      <div class="sh-block-confirm-actions">
        <button type="button" class="sh-block-confirm-btn is-cancel" @click="cancel">Cancel</button>
        <button type="button" class="sh-block-confirm-btn is-confirm" @click="confirm">{{ copy.confirm }}</button>
      </div>
    </div>
  </div>
</template>

<script>
// Confirmation dialog for blocking or unblocking a user. Reuses the
// members-modal overlay/box styling so it matches the rest of messaging.
// Purely presentational: the parent decides what "confirm" does.
const COPY = {
  block: {
    title: "Block this user?",
    body: "You’ll no longer see messages and comments from this user. You can unblock at any time.",
    confirm: "Confirm"
  },
  unblock: {
    title: "Unblock this user?",
    body: "Unblocking this user will allow you to see their messages and comments again. Would you like to continue?",
    confirm: "Unblock"
  }
};

export default {
  name: "BlockUserConfirm",
  props: {
    visible: { type: Boolean, default: false },
    mode: { type: String, default: "block", validator: v => v in COPY }
  },
  emits: ["confirm", "cancel"],
  computed: {
    copy() {
      return COPY[this.mode] || COPY.block;
    }
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>
